import styled from "styled-components";
import { useContext } from "react";
import { Dialog } from "primereact/dialog";
import { DialogWindowContext } from "../../Contexts/DialogueWindowContext";

function Dialogue() {
  const DialogWindow = useContext(DialogWindowContext);
  const { children, header, setDialogProps, showEditWindow } =
    useContext(DialogWindowContext);
  return (
    <Dialog
      position="bottom"
      maximizable
      header={header}
      visible={showEditWindow}
      onHide={() =>
        setDialogProps({
          ...DialogWindow,
          showEditWindow: false,
        })
      }
    >
      {children}
    </Dialog>
  );
}

export default Dialogue;
